import { action, select } from 'satcheljs/lib/legacy';
import inboxRuleStore from '../store/store';
/**
 * Show or hide the inbox rule dialog
 * @param shouldShow whether this is to show the inbox rule dialog
 * @param state the state which contains the inbox rule store
 */
export default action('showHideInboxRuleDialog')(select({
    inboxRuleStore: function () { return inboxRuleStore; },
})(function showHideInboxRuleDialog(shouldShow, state) {
    state.inboxRuleStore.isInboxRuleDialogShown = shouldShow;
    if (!shouldShow) {
        // Clear the create rule view state if hiding the dialog
        state.inboxRuleStore.inboxRuleRequestStatus = 0 /* NotInitiated */;
        state.inboxRuleStore.selectedFolderId = null;
    }
}));
//# sourceMappingURL=showHideInboxRuleDialog.js.map